import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { SpinnerOverlayComponent } from 'src/app/_shared/components/common/spinner-overlay/spinner-overlay.component';

@Injectable({
  providedIn: 'root'
})
export class SpinnerOverlayService {

  private overlayRef: OverlayRef = null;

  private showCount: number = 0;

  constructor(private overlay: Overlay) { }

  public show(message = '') {
    // Returns an OverlayRef (which is a PortalHost)

    this.showCount++;
    //console.log('show spinner1-' + this.showCount);

    if ( !this.overlayRef && this.showCount == 1) {
      this.overlayRef = this.overlay.create();
    }

    if (this.showCount == 1) {

      try {
        const spinnerOverlayPortal = new ComponentPortal(SpinnerOverlayComponent);
        const component = this.overlayRef.attach(spinnerOverlayPortal); // Attach ComponentPortal to PortalHost
      } catch (error) {

      }
    }
    // Create ComponentPortal that can be attached to a PortalHost
  }

  public hide() {

    this.showCount--;

    //console.log('hide spinner1-' + this.showCount);
    if (this.showCount < 1 && !!this.overlayRef) {
      this.showCount = 0;
      this.overlayRef.detach();
    }
  }
}
